// ============================================================================
// Pick / Deliver tag (the server still calls these first mile / last mile). Built like ExpressTag (worded, with
// an icon, never colour alone) and rendered in the same tag row beside them, so
// the three read as one family.
//
// It exists because the Vendor Dashboard merged the board's two tabs into one
// page: on OMS Operations the half of the operation a booking belongs to is
// implied by which tab you are on, and here nothing says it. Off the `board_lane`
// every row already carries — inbound (towards our warehouse) vs customer-bound.
// ============================================================================
import { ExportOutlined, ImportOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";
import { BoardLane } from "../types";

const META: Record<BoardLane, { label: string; color: string; help: string; icon: React.ReactNode }> = {
  // Colours and icons chosen to clear the row's existing tags: express is red with a bolt,
  // unloading volcano with a download arrow, intercity geekblue. So purple/cyan and the
  // import/export arrows, which also carry the direction.
  first_mile: {
    label: "pick",
    color: "purple",
    help: "Pick — goods collected and moving towards our warehouse (a supplier pickup or a warehouse transfer).",
    icon: <ImportOutlined />,
  },
  last_mile: {
    label: "deliver",
    color: "cyan",
    help: "Deliver — the leg that carries the goods to the customer.",
    icon: <ExportOutlined />,
  },
};

const MileTag: React.FC<{ lane?: BoardLane | null }> = ({ lane }) => {
  const meta = lane ? META[lane] : undefined;
  if (!meta) return null;
  return (
    <Tooltip title={meta.help}>
      <Tag color={meta.color} icon={meta.icon} style={{ marginInlineEnd: 0, cursor: "help" }}>
        {meta.label}
      </Tag>
    </Tooltip>
  );
};

export default MileTag;
